module.exports = __webpack_public_path__ + "static/media/analitica.7236d735.jpg";